import { createFileRoute } from "@tanstack/react-router";
import { TradeGuidePage, seoHead } from "@/components/hubs/HubPages";
import { TRADE_GUIDES } from "@/lib/regionalHubs";

const DATA = TRADE_GUIDES.find((x) => x.slug === "/learn/electrician-leads-colorado")!;

export const Route = createFileRoute("/learn/electrician-leads-colorado")({
  head: () => seoHead("/learn/electrician-leads-colorado", "How Colorado Electricians Get More Calls | Guide", "Guide for Colorado electricians: panel and EV charger pages, Google Maps, and reviews that bring better jobs.", "article"),
  component: () => <TradeGuidePage guide={DATA} />,
});
